export const compareValues = (key, order = 'asc') => {
  return (a, b) => {
    if (!a[key] || !b[key]) return 0;
    let comparison = a[key].localeCompare(b[key]);

    return order === 'desc' ? comparison * -1 : comparison;
  };
};

export const sortByOrder = (list) => list.sort((a, b) => a.order - b.order);

export const formatDate = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

const randomFromRange = (from, to) =>
  Math.floor(Math.random() * (to - from) + from);
export const fakeDelay = (func) => setTimeout(func, randomFromRange(50, 200));

export const linkCheckSlash = (current, next) =>
  current[current.length - 1] === '/' ? current + next : current + `/${next}`;

const checkForDayAndHour = (wsList) =>
  wsList.some((ws) => ws.cyclic_day && +ws.cyclic_day > 0 && ws.cyclic_hour);
const checkForFirstLesson = (wsList) =>
  wsList.some((ws) => ws.show_lesson_time);
const checkForSummerplayWorkshopType = (wsList) =>
  wsList.some((ws) => ws.type === 1);

const isAllChildrenWorkshop = (wsList) =>
  wsList.some((ws) => ws.allow_external_signups);

export const getMarkerColors = (wsList) => {
  const onlyLocalChildren = 'rgb(37,144,193)';
  const allChildrenColor = 'rgb(253, 158, 32)';

  const dayAndHour = checkForDayAndHour(wsList);
  const firstLesson = checkForFirstLesson(wsList);
  const summerplayWorkshop = checkForSummerplayWorkshopType(wsList);

  if (summerplayWorkshop)
    return { first: 'rgb(253, 158, 32)', second: null };

  if (isAllChildrenWorkshop(wsList))
    return { first: allChildrenColor, second: null };

  return { first: onlyLocalChildren, second: null };
};
